import React, { FunctionComponent } from 'react';
import { GalleryIconStyles as S } from './GalleryIcon.styles';

export interface GalleryIconProps {
  count?: number;
}

const GalleryIcon: FunctionComponent<GalleryIconProps> = (props) => {
  return (
    <S.Container>
      {props.count ? <S.Count>{props.count}</S.Count> : null}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
        <g id="GALLERY_ICON" data-name="GALLERY ICON" transform="translate(-176 -252)">
          <g id="collections_black_24dp" transform="translate(176 254)">
            <path id="Path_19093" data-name="Path 19093" d="M0,0H40V40H0Z" fill="none" />
            <path
              id="Path_19094"
              data-name="Path 19094"
              d="M32,5.333v20H12v-20H32M32,2H12A3.343,3.343,0,0,0,8.667,5.333v20A3.343,3.343,0,0,0,12,28.667H32a3.343,3.343,0,0,0,3.333-3.333v-20A3.343,3.343,0,0,0,32,2ZM17.833,18.117l2.817,3.767,4.133-5.167,5.55,6.95H13.667ZM2,8.667V32a3.343,3.343,0,0,0,3.333,3.333H28.667V32H5.333V8.667Z"
              transform="translate(1.333 1.333)"
              fill="currentColor"
            />
          </g>
          {/* <circle
            id="Ellipse_57"
            data-name="Ellipse 57"
            cx="7"
            cy="7"
            r="7"
            transform="translate(204 252)"
            fill="currentColor"
          />
          {props.count ? (
            <text
              id="_5"
              data-name="5"
              transform="translate(208 262)"
              fontSize="8"
              fontFamily="Helvetica Neue LT W05_73 Bd Ex"
              letterSpacing="0.02em"
            >
              <tspan x="0" y="0">
                {props.count}
              </tspan>
            </text>
          ) : null} */}
        </g>
      </svg>
    </S.Container>
  );
};

export default GalleryIcon;
